import { FC, useState } from 'react';
import ReactToPrint from 'react-to-print';
import { Row } from 'react-bootstrap';
import { AiFillPrinter } from 'react-icons/ai';
import '../../src/app.css';
import { MyButton } from './MyButton';
import QRCode from "react-qr-code";


import styles from '../Pages/Funcionarios/funcionarios.module.css';

interface FieldConfig {
    id: string;
    label: string;
    enabled: boolean;
    position: number;
    span: number;
}

interface IPulseiraComponent {
    codeNumber: number,
    fullName: string,
    staff: string,
    cpf: string,
    function: string,
    company: string,
    fieldsOrder?: FieldConfig[],
    showQRCode?: boolean,
    showLabels?: boolean,
    labelFontSize?: number,
    valueFontSize?: number
}

export const PulseiraComponent: FC<IPulseiraComponent> = (props) => {
    var contentRef: any = null;

    const [showQrCode, setShowQrCode] = useState(true);

    // Valores padrão para showQRCode e showLabels
    const displayQRCode = props.showQRCode !== undefined ? props.showQRCode : true;
    const displayLabels = props.showLabels !== undefined ? props.showLabels : true;
    
    // Valores padrão para os tamanhos de fonte
    const labelSize = props.labelFontSize || 14;
    const valueSize = props.valueFontSize || 12;

    // Função para renderizar um campo baseado no ID
    const renderField = (fieldId: string) => {
        const fieldData: { [key: string]: { label: string, value: string } } = {
            'nome': { label: 'Nome', value: props.fullName },
            'empresa': { label: 'Empresa', value: props.company },
            'setor': { label: 'Setor', value: props.staff },
            'funcao': { label: 'Função', value: props.function }
        };

        const field = fieldData[fieldId];
        if (!field) return null;

        return (
            <div className='gap-2 items-center' style={{ paddingRight: '10px' }}>
                {displayLabels && <b style={{ fontSize: `${labelSize}px` }}>{field.label}:</b>}
                <span style={{ fontSize: `${valueSize}px`, marginLeft: displayLabels ? '5px' : '0px' }}>
                    <b>{field.value}</b>
                </span>
            </div>
        );
    };

    return (
        <div>
            <Row>
                <div ref={el => contentRef = el} className='ml-5 mt-1 flex items-center gap-x-2' >
                    {displayQRCode && (
                        <div>
                            <QRCode value={props.codeNumber.toString()} size={60} />
                        </div>
                    )}
                    <div>
                        {props.fieldsOrder ? (
                            // Renderização em grid 2x2 com suporte a span (campos que ocupam múltiplos quadrados)
                            <div className="grid grid-cols-2" style={{ gap: '4px' }}>
                                {[1, 2, 3, 4].map(position => {
                                    // Verificar se esta posição está ocupada por um campo
                                    const field = props.fieldsOrder?.find(f => {
                                        if (!f.enabled) return false;
                                        // Verificar se este campo ocupa esta posição
                                        const startPos = f.position;
                                        const endPos = f.position + f.span - 1;
                                        return position >= startPos && position <= endPos;
                                    });

                                    // Se o campo começa nesta posição, renderiza
                                    if (field && field.position === position) {
                                        return (
                                            <div 
                                                key={position} 
                                                style={{ 
                                                    paddingRight: '10px',
                                                    gridColumn: field.span > 1 ? `span ${field.span}` : 'auto'
                                                }}
                                            >
                                                {renderField(field.id)}
                                            </div>
                                        );
                                    }
                                    
                                    // Se a posição está ocupada mas não é o início do campo, pula
                                    if (field && field.position !== position) {
                                        return null;
                                    }

                                    // Posição vazia
                                    return (
                                        <div key={position} style={{ paddingRight: '10px' }}>
                                            <div style={{ minHeight: '20px' }}></div>
                                        </div>
                                    );
                                })}
                            </div>
                        ) : (
                            // Renderização padrão (compatibilidade retroativa)
                            <>
                                <div className="grid grid-cols-2">
                                    <div className='gap-2 items-center' style={{ paddingRight: '10px' }}>
                                        {displayLabels && <b style={{ fontSize: '14px' }}>Nome:</b>}
                                        <span style={{ fontSize: '12px', marginLeft: displayLabels ? '5px' : '0px' }}>
                                            <b>{props.fullName}</b>
                                        </span>
                                    </div>

                                    <div className='gap-2 items-center' style={{ paddingRight: '10px' }}>
                                        {displayLabels && <b style={{ fontSize: '14px' }}>Empresa:</b>}
                                        <span style={{ fontSize: '12px', marginLeft: displayLabels ? '5px' : '0px' }}>
                                            <b>{props.company}</b>
                                        </span>
                                    </div>
                                </div>

                                <div className="grid grid-cols-2">
                                    <div className='gap-2 items-center' style={{ paddingRight: '10px' }}>
                                        {displayLabels && <b style={{ fontSize: '14px' }}>Setor:</b>}
                                        <span style={{ fontSize: '12px', marginLeft: displayLabels ? '5px' : '0px' }}>
                                            <b>{props.staff}</b>
                                        </span>
                                    </div>

                                    <div className='gap-2 items-center' style={{ paddingRight: '10px' }}>
                                        {displayLabels && <b style={{ fontSize: '14px' }}>Função:</b>}
                                        <span style={{ fontSize: '12px', marginLeft: displayLabels ? '5px' : '0px' }}>
                                            <b>{props.function}</b>
                                        </span>
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </Row>
            <Row>
                <ReactToPrint
                    content={() => contentRef}
                    trigger={() => (
                        <div className='row'>
                            <div className="col-6">

                            </div>
                            <div className="col-6">
                                <MyButton endIcon={<AiFillPrinter />}>
                                    Imprimir Pulseira
                                </MyButton>
                            </div>
                        </div>
                    )}
                />
            </Row>
        </div>
    )
}

